import React from 'react';
import c from 'classnames';

import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';

import WebformWrapper from '../../../../../components/Webform/Wrapper';
import WysiwygField from '../../../../../components/WysiwygField';
import SwirlIllustrations from '../../../../../components/SwirlIllustrations';

import '../style.scss';

const ParagraphCTA = ({ entity, titleOverwrite = null, variantOverwrite = null, linkHrefOverwrite = null, linkTitleOverwrite = null }) => {
  const icon = entity.getIn(['field_icon', 0, 'value']);
  const title = titleOverwrite || entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const linkHref = linkHrefOverwrite || entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = linkTitleOverwrite || entity.getIn(['field_link', 0, 'title']);
  const webform = entity.getIn(['field_webform', 0, 'target_id']);
  const colorVariant = variantOverwrite || entity.getIn(['field_variant', 0, 'value']) || 'default';
  const classNames = c('Paragraph', 'ParagraphCTA', {
    'ParagraphCTAWithIcon': icon,
    [`ParagraphCTA--variant--${colorVariant}`]: colorVariant,
  });

  return (
    <Container className={classNames}>
      <div className="row">
        <div className="col-12 col-md-12 col-lg-10 offset-lg-1">
          <div className="ParagraphCTA__inner">
            {icon && (
              <div className="ParagraphCTA__icon"><div className={`icon-before icon-${icon}`} /></div>
            )}
            <div className="ParagraphCTA__inner__content">
              {title && (
                <h2>{title}</h2>
              )}
              {body && (
                <div className="ParagraphCTA__body">
                  <WysiwygField
                    property="schema:text"
                    html={body}
                  />
                </div>
              )}
            </div>

            {webform && webform !== 'webform_' && (
              <div className="ParagraphCTA__inner__webform">
                <WebformWrapper id={webform} />
              </div>
            )}

            <div className="ParagraphCTA__inner__actions">
              <Button
                href={linkHref}
                className="Button--primary"
              >
                {linkTitle}
                <div className="icon icon-arrow-right icon-variant-2" />
              </Button>

              <SwirlIllustrations
                variant="paragraph"
                colorVariant={colorVariant}
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphCTA;
